import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useEffect } from "react";

import Login from "./pages/Login";
import Pos from "./pages/Pos";
import SalesDetail from "./pages/SalesDetail";
import Clients from "./pages/Clients";
import Products from "./pages/Products";
import Suppliers from "./pages/Suppliers";
import Purchase from "./pages/Purchase";
import InvoiceList from "./pages/invoices/InvoiceList";
import Reports from './pages/reports/Reports';
import Mesas from './pages/Mesas';
import ParaLlevar from './pages/ParaLlevar';
import Meseros from './pages/Meseros';
import OrdenMesa from './pages/OrdenMesa';
import Comedor from './pages/Comedor';
import InventoryAdjustments from "./pages/InventoryAdjustments";

import CashRegister from './components/cash/CashRegister';
import CashSessionHistory from "./components/cash/CashSessionHistory";
import CashSessionDetail from "./components/cash/CashSessionDetail";

import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import PrivateRoute from "./components/PrivateRoute";

function AppRoutes() {
  const { user, loading } = useAuth();

  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={user.tipo_negocio === 'comedor' ? '/comedor' : '/mesas'} replace /> : <Navigate to="/login" replace />} />
      <Route path="/login" element={user ? <Navigate to={user.tipo_negocio === 'comedor' ? '/comedor' : '/mesas'} replace /> : <Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <div className="d-flex">
              <Sidebar />
              <div className="main-content">
                <TopBar />
                <div className="content-wrapper">
                  <Routes>
                    <Route path="/pos" element={<Pos />} />
                    <Route path="/sales/:id" element={<SalesDetail />} />

                    <Route path="/cash" element={<CashRegister />} />
                    <Route path="/cash/history" element={<CashSessionHistory />} />
                    <Route path="/cash/session/:id" element={<CashSessionDetail />} />

                    <Route path="/purchase" element={<Purchase />} />
                    <Route path="/invoices" element={<InvoiceList />} />

                    <Route path="/clients" element={<Clients />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/suppliers" element={<Suppliers />} />

                    <Route path="/reports" element={<Reports />} />

                    {/* Restaurant */}
                    <Route path="/mesas" element={<Mesas />} />
                    <Route path="/para-llevar" element={<ParaLlevar />} />
                    <Route path="/meseros" element={<Meseros />} />
                    <Route path="/ordenes/:id" element={<OrdenMesa />} />
                    <Route path="/inventory-adjustments" element={<InventoryAdjustments />} />

                    {/* Diner */}
                    <Route path="/comedor" element={<Comedor />} />

                    <Route path="*" element={<h4>Page not found</h4>} />
                  </Routes>
                </div>
              </div>
            </div>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;